import type { NewsArticlesQuery, NewsLang } from '@/schemas/market-news'
import type { NewsFeedQuery } from '@/schemas/news'

/**
 * Query key factory.
 *
 * The feed keys on the whole query object — scope, search text and sort each
 * change which stories come back, and an infinite query caches every loaded
 * page under one key, so a key that missed the search box would keep serving
 * the unfiltered pages under a filter.
 */
export const newsKeys = {
  all: ['news'] as const,
  feeds: () => [...newsKeys.all, 'feed'] as const,
  feed: (query: NewsFeedQuery) => [...newsKeys.feeds(), query] as const,
  count: (query: NewsFeedQuery | null) => [...newsKeys.all, 'count', query] as const,
  stories: (query: NewsArticlesQuery) => [...newsKeys.all, 'stories', query] as const,
  article: (id: string, lang: NewsLang) => [...newsKeys.all, 'article', id, lang] as const,
}
